import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * Retrieves a list of areas with their ski information.
   *
   * @returns {AxiosPromise}
   */
  getSkiAreas() {
    return conduit.get('ski/areas');
  },

  /**
   * Retrieves a list of ski facts for an area.
   *
   * @param id
   * @returns {AxiosPromise}
   */
  getSkiFactsForArea(id) {
    return conduit.get(`ski/facts/${id}`);
  },

  /**
   * Retrieves a list of available units for a ski fact.
   *
   * @returns {AxiosPromise}
   */
  getSkiFactUnits() {
    return conduit.get('ski/facts/units');
  },

  /**
   * Retrieves information about an area.
   *
   * @param id
   * @returns {AxiosPromise}
   */
  getArea(id) {
    return conduit.get(`area/${id}`);
  },

  /**
   * Retrieves snow guarantee for an area.
   *
   * @param id
   * @returns {AxiosPromise}
   */
  getSnowGuaranteeForArea(id) {
    return conduit.get(`ski/snow-guarantee/${id}`);
  },

  /**
   * Updates snow guarantee for an area.
   *
   * @param id
   * @param data
   * @returns {AxiosPromise}
   */
  updateSnowGuaranteeForArea(id, data) {
    return conduit.put(`ski/snow-guarantee/${id}`, data);
  },

  /**
   * Updates the ski facts for an area.
   *
   * @param id
   * @param data
   * @returns {AxiosPromise}
   */
  updateSkiFactsForArea(id, data) {
    return conduit.put(`ski/facts/${id}`, data);
  },

  /**
   * Fetch slope maps for area id.
   *
   * @param id
   * @returns {AxiosPromise}
   */
  fetchSlopeMaps(id) {
    return conduit.get(`ski/slope-maps/${id}`);
  },

  /**
   * Upload image.
   *
   * @param areaId
   * @param image
   * @param priority
   * @returns {AxiosPromise}
   */
  uploadSlopeMap(areaId, image, priority) {
    const formData = new FormData();
    formData.append('image', image.file);
    return conduit.post(`ski/slope-maps/${areaId}`,
      formData,
      { priority, title: image.title },
      { 'Content-Type': 'multipart/form-data' });
  },

  /**
   * Remove slope map.
   *
   * @param areaId
   * @param image
   * @returns {AxiosPromise}
   */
  removeSlopeMap(areaId, image) {
    return conduit.delete(`ski/slope-maps/${areaId}`, {
      id: image.id,
      imageUrl: image.large,
      priority: image.priority,
    });
  },

  /**
   * Rearrange the order of the slope maps.
   *
   * @param areaId
   * @param images
   * @returns {AxiosPromise}
   */
  updateSlopeMaps(areaId, images) {
    return conduit.put(`ski/slope-maps/${areaId}`, {
      images,
    });
  },

  /**
   * Get pickup uplaces
   *
   * @param areaId
   */
  getPickupPlaces(areaId) {
    return conduit.get(`ski/pickups/${areaId}`);
  },

  /**
   * Update pickup places
   *
   * @param areaId
   * @param pickupPlaces
   */
  updatePickupPlaces(areaId, pickupPlaces) {
    return conduit.put(`ski/pickups/${areaId}`, pickupPlaces);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/areas-service.js